import { detectAppChanges } from '../../../lib/detectAppChanges.js';
import { findApiByAction } from '../../../../../utils/findApiByAction.js';

export const appActionPath = {
  key: 'path',
  type: 'app',
  label: 'Path',
  description: 'The HTTP path to use for the action.',
  path: 'actions[id:{{actionId}}].api.path',
  shouldRun: ({ changes, actionId }) =>
    detectAppChanges(changes, {
      type: 'action',
      actionId,
      keys: ['', 'api.path', 'method'],
      custom: () => {
        return changes?.filter((n) => n?.type === 'appDoc')?.length > 0;
      }
    }),
  context: ['actionDocs'],
  mapContext: ({ app, action, actionDocs }) => ({
    name: action?.name,
    appName: app?.name,
    baseUrl: findApiByAction(app, action)?.baseUrl,
    path: action?.api?.path,
    actionDocs
  }),
  postProcess: ({ suggestion }) => {
    const data = suggestion?.suggestion || {};
    const { suggestedValue } = data;

    if (!suggestedValue || suggestedValue === 'undefined') {
      return null;
    }

    return { ...suggestion, suggestion: { ...data, suggestedValue } };
  },
  prompt: 'appActionPath'
};
